<div class="bg-white my-5" style="font-family: Montserrat;">
<div class="my-4">
  <div class="flex gap-3 items-center mx-4">
    <img (click)="backClicked()"class="rounded-full w-6 h-6 bg-blue-500 cursor-pointer mt-3" src="assets/back-icon.svg">
      <p class="font-semibold text-xl mt-3" >Authentication</p>
      <!-- <span class="text-gray-500 mt-3">|</span> -->
      <!-- <div class="slideToggle px-2 py-1 bg-blue-100 rounded-lg relative cursor-pointer flex items-center justify-center gap-2 mt-3" style="border: 1px solid #386AF6;" [class.checked]="isChecked" (click)="toggle()">
        <span style="font-size: 12px;">Active</span>
        <div class="bg-blue-500 rounded-full" style="width: 28px; height: 14px;">
          <div class="auth-slider"></div>
        </div>
      </div> -->
  </div>
</div>
    <div
      class="flex flex-col border px-4 py-2 bg-white rounded-2xl mx-4" 
    >
      <p class="font-semibold text-base">Select method of authentication</p>
      <label class="text-base">
        <input #radioButton1 class="text-blue-500 mr-2 font-light my-3" type="radio" name="myRadio" value="option1" (change)="enableConfirmButton(radioButton1.checked)"/>
         Authentication through SwiftChat (Native)
      </label>
      <label class="text-base" style="display: none;">
        <input #radioButton2  class="text-blue-500 mr-2 font-light" type="radio" name="myRadio" value="option2" (change)="enableConfirmButton(radioButton2.checked)"/>
        External Authentication (Webview)
      </label>
      <p class="bg-blue-100 px-2 py-1 inline-block my-3 " style="width: fit-content; border-radius: 2.89px; font-size: 12px; display: none; ">
        <span class="font-semibold">Note: </span>Pick your authentication after
        activating (can't change later without deactivating)
      </p>
      <button
      (click)="confirmButtonClick()"
        class= "px-5 py-2 text-white rounded-full my-4" style="width: fit-content; font-size: 14px;"
        [ngStyle]="{ 'background-color': (radioButton1.checked || radioButton2.checked) ? '#386AF6' : '#E0E7FF' }"
        [disabled]="!radioButton1.checked && !radioButton2.checked"
      >
        Confirm
      </button>
    </div> 
  </div>
